export const hotTopics = [
  {
    id: 1,
    rank: 1,
    title: "直播间同框，主播和演员谁更抢镜",
    heat: 98650,
    trend: "up",
    category: "直播同框",
    summary: "当镜头同时给到两种职业身份，话语权的分配往往比人气更有看头。",
  },
  {
    id: 2,
    rank: 2,
    title: "同一个品牌，换了不同量级的合作对象",
    heat: 87210,
    trend: "up",
    category: "品牌代言",
    summary: "从代言人到品牌挚友，头衔背后藏着一套完整的商业位次逻辑。",
  },
  {
    id: 3,
    rank: 3,
    title: "综艺同台，镜头时长到底说明了什么",
    heat: 76430,
    trend: "flat",
    category: "综艺同台",
    summary: "剪辑台上的每一秒都不随机，镜头分配是咖位最直观的注脚。",
  },
  {
    id: 4,
    rank: 4,
    title: "红毯顺序与压轴，位置学里的隐藏规则",
    heat: 65180,
    trend: "down",
    category: "时尚红毯",
    summary: "出场顺序、站位朝向、合影位置，构成一套完整的红毯位置学。",
  },
  {
    id: 5,
    rank: 5,
    title: "选角名单流出后，讨论为什么总跑偏",
    heat: 58720,
    trend: "up",
    category: "影视选角",
    summary: "当流量艺人进入正剧视野，争议往往不在演技而在预期管理。",
  },
  {
    id: 6,
    rank: 6,
    title: "点赞、票房、收视：三套评价体系怎么换算",
    heat: 51240,
    trend: "flat",
    category: "流量观察",
    summary: "不同赛道的成绩单没有统一汇率，强行比较最容易得出错误结论。",
  },
  {
    id: 7,
    rank: 7,
    title: "热度退潮之后，谁还在稳定营业",
    heat: 46890,
    trend: "down",
    category: "流量观察",
    summary: "短期爆红与长期经营是两件事，后者才真正决定位置稳不稳。",
  },
  {
    id: 8,
    rank: 8,
    title: "粉丝体量相近，为什么商业报价差一截",
    heat: 40160,
    trend: "flat",
    category: "商业价值",
    summary: "粉丝数量只是入场券，转化结构与人群质量才是报价的分水岭。",
  },
];